import { render, staticRenderFns } from "./EditFileUploads.vue?vue&type=template&id=0d9c2ee7"
import script from "./EditFileUploads.vue?vue&type=script&lang=js"
export * from "./EditFileUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports